var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokeTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Smoke_Temp_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Smoke_Temp_",
    "data-name": "Smoke & Temp ",
    clipPath: "url(#clip-Smoke_Temp_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smoke-detector",
    transform: "translate(8.001 11.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M85.333,331.852v18.963c23.627,22.081,87.111,37.926,161.938,37.926S385.582,372.9,409.21,350.815V331.852Z",
    transform: "translate(0 -8.462)",
    fill: "#d5dced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M341.333,379.259c-78.86,0-145.766-15.845-170.667-37.926v-9.481H85.333v18.963c24.9,22.081,91.806,37.926,170.667,37.926,37.4,0,72.034-3.6,100.85-9.7Q349.174,379.247,341.333,379.259Z",
    transform: "translate(-6.195 -8.462)",
    fill: "#c7cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M419.522,350.815H75.021c-10.014,0-18.132-8.489-18.132-18.963V303.408H437.654v28.444C437.654,342.324,429.535,350.815,419.522,350.815Z",
    transform: "translate(0 -8.462)",
    fill: "#e4eaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M170.667,331.852V303.408H56.889v28.444a18.964,18.964,0,0,0,18.963,18.963H189.63A18.963,18.963,0,0,1,170.667,331.852Z",
    transform: "translate(0 -8.462)",
    fill: "#d5dced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M485.062,237.037H9.481L55.21,312.889H439.332Z",
    transform: "translate(0 -5.077)",
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M256,237.037H9.481l47.408,75.852H256Z",
    transform: "translate(0 -5.077)",
    fill: "#959cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M466.1,237.037H28.444l45.589,75.852H420.509Z",
    transform: "translate(0 -5.077)",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M485.385,256H9.158A9.324,9.324,0,0,1,0,246.519V132.741a9.324,9.324,0,0,1,9.158-9.481H485.384a9.324,9.324,0,0,1,9.158,9.481V246.519A9.322,9.322,0,0,1,485.385,256Z",
    fill: "#e4eaf8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 28.444,
    cy: 28.444,
    r: 28.444,
    transform: "translate(218.827 161.186)",
    fill: "#ff5050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M270.222,203.852a28.342,28.342,0,0,1-25.886-40.109,28.41,28.41,0,1,0,37.551,37.551A28.238,28.238,0,0,1,270.222,203.852Z",
    transform: "translate(-8.68 -1.622)",
    fill: "#c84146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M132.741,246.519V132.741a9.481,9.481,0,0,1,9.481-9.481H9.481A9.481,9.481,0,0,0,0,132.741V246.519A9.481,9.481,0,0,0,9.481,256H142.222A9.481,9.481,0,0,1,132.741,246.519Z",
    fill: "#d5dced"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(75.852 250.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 18.963,
    height: 56.889,
    fill: "#959cb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 18.963,
    height: 56.889,
    transform: "translate(37.926)",
    fill: "#959cb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 18.963,
    height: 56.889,
    transform: "translate(75.852)",
    fill: "#959cb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(172.173 250.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 18.963,
    height: 56.889,
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 18.963,
    height: 56.889,
    transform: "translate(37.926)",
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 18.963,
    height: 56.889,
    transform: "translate(75.851)",
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 18.963,
    height: 56.889,
    transform: "translate(113.777)",
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 18.963,
    height: 56.889,
    transform: "translate(151.703)",
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 18.963,
    height: 56.889,
    transform: "translate(189.629)",
    fill: "#afb9d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 18.963,
    height: 56.889,
    transform: "translate(227.555)",
    fill: "#afb9d2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeTemp);
export default __webpack_public_path__ + "static/media/Smoke & Temp.4b14ae3e969338211ed1375b483f762a.svg";
export { ForwardRef as ReactComponent };